import axios from '../api'
import {
  GetTurnstileToken,
  TURNSTILE_FIELD,
  takeChallengeToken,
} from '../turnstile/challenge'

interface PasswordResetRequest {
  email: string
  getToken: GetTurnstileToken
}

export const requestPasswordReset = async ({ email, getToken }: PasswordResetRequest) => {
  const token = await takeChallengeToken(getToken)

  return axios.post('/auth/password-reset-request/', {
    email,
    ...(token ? { [TURNSTILE_FIELD]: token } : {}),
  })
}
